import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=4d804046&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=ts&"
export * from "./Credit.vue?vue&type=script&lang=ts&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=4d804046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d804046",
  null
  
)

export default component.exports